import script from "./tickets-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tickets-modal.vue?vue&type=script&setup=true&lang=js"

import "./tickets-modal.vue?vue&type=style&index=0&id=23a05cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a05cf2"]])

export default __exports__